export default __webpack_public_path__ + "static/media/sliderPoster -3.9812ff9d.jpg";